<template>
  <div class="single-column">
    <section class="single-column__section">
      <h2 class="single-column__heading">{{ title }}</h2>
      <div
        class="login-block">
        <form
          class="form--error"
          @submit.prevent="onRegisterClicked">
          <div class="form-wrap">
            <div
              v-if="isCompany && company.name"
              class="form-group">
              <div class="form-label">
                <label
                  class="control-label"
                  for="email">会社名
                </label>
              </div>
              <div class="form-item">
                {{ company.name }}
              </div>
            </div>
            <div class="form-group">
              <div class="form-label">
                <label
                  class="control-label"
                  for="email">メールアドレス
                </label>
              </div>
              <div class="form-item">
                <input
                  id="email"
                  v-model="form.email"
                  class="form-control"
                  type="email"
                  name="email"
                  placeholder="例）sample@example.com"
                  :disabled="form.rsId">
                <p
                  v-if="errors.email"
                  class="error-text">
                  {{ errors.email[0] }}
                </p>
                <p
                  v-if="!isCompany && errors['mate.code']"
                  class="error-text">
                  {{ errors['mate.code'][0] }}
                </p>
              </div>
            </div>
            <div class="form-group">
              <div class="form-label">
                <label
                  class="control-label"
                  for="password">パスワード（8文字以上）
                </label>
              </div>
              <div class="form-item">
                <input
                  id="password"
                  v-model="form.password"
                  class="form-control"
                  type="password"
                  name="password"
                  placeholder="半角英数のみ、8文字以上">
                <p
                  v-if="errors.password"
                  class="error-text">
                  {{ errors.password[0] }}
                </p>
              </div>
            </div>
            <div class="form-group">
              <div class="form-label">
                <label
                  class="control-label"
                  for="password_confirmation">パスワード再入力</label>
              </div>
              <div class="form-item">
                <input
                  id="password_confirmation"
                  v-model="form.password_confirmation"
                  class="form-control"
                  type="password"
                  name="password_confirmation"
                  placeholder="半角英数のみ、8文字以上">
                <p
                  v-if="errors.password_confirmation"
                  class="error-text">
                  {{ errors.password_confirmation[0] }}
                </p>
              </div>
            </div>

            <div
              v-if="mateFormType === 'mate'"
              class="form-group">
              <div class="form-label">
                <label
                  class="control-label"
                  for="graduation_year">卒業予定年月</label>
              </div>
              <div class="form-item">
                <div class="form-item-inline form-item-inline--sp-reset">
                  <div class="date-select">
                    <div class="select-container">
                      <span class="form-item__wrap">
                        <div class="c-select_wrap">
                          <select
                            v-model="form.mate.graduation_year"
                            class="form-control c-select"
                            name="graduation_year"
                            @change="createGraduationMonthOptions">
                            <option
                              v-for="(option, index) in graduationYearOptions"
                              :key="`year${index}`"
                              :value="option.value">
                              {{ option.text }}
                            </option>
                          </select>
                        </div>
                        <span class="c-select_wrap__text">年</span>
                      </span>
                      <span class="form-item__wrap">
                        <div class="c-select_wrap">
                          <select
                            v-model="form.mate.graduation_month"
                            class="form-control c-select"
                            name="graduation_month">
                            <option
                              v-for="(option, index) in graduationMonthOptions"
                              :key="`month${index}`"
                              :value="option.value">
                              {{ option.text }}
                            </option>
                          </select>
                        </div>
                        <span class="c-select_wrap__text">月</span>
                      </span>
                    </div>
                  </div>
                </div>
                <p
                  v-if="errors['mate.graduation_year']"
                  class="error-text">
                  {{ errors['mate.graduation_year'][0] }}
                </p>
                <p
                  v-if="errors['mate.graduation_month']"
                  class="error-text">
                  {{ errors['mate.graduation_month'][0] }}
                </p>
              </div>
            </div>
            <!-- 学生番号を入力するフィールド -->
            <div
              v-if="mateFormType === 'life'"
              class="form-group">
              <div class="form-label">
                <label
                  class="control-label"
                  for="student_id">{{ personal_number_text }}</label>
              </div>
              <div class="form-item">
                <input
                  id="student_id"
                  v-model="form.mate.student_id"
                  class="form-control"
                  type="text"
                  name="student_id"
                  placeholder="例）1234567890">
                <p
                  v-if="errors['mate.student_id']"
                  class="error-text">
                  {{ errors['mate.student_id'][0] }}
                </p>
              </div>
            </div>

            <div
              v-if="!isCompany && mateFormType === ''"
              class="form-group">
              <div class="form-label">
                <label
                  class="control-label"
                  for="ageGroup">1. 年代を教えてください。</label>
              </div>
              <div class="form-item">
                <div
                  v-for="(ageGroup, index) in ageGroups"
                  :key="`ageGroup${index}`"
                  class="radio">
                  <label :for="`ageGroup${index}`">
                    <input
                      :id="`ageGroup${index}`"
                      v-model="form.sign_up_enquete.ageGroup"
                      type="radio"
                      name="ageGroup"
                      :value="ageGroup">
                    <div class="option-input"></div>
                    {{ ageGroup }}
                  </label>
                </div>
                <p
                  v-if="errors['sign_up_enquete.ageGroup']"
                  class="error-text">
                  {{ errors["sign_up_enquete.ageGroup"][0] }}
                </p>
              </div>
            </div>
            <div
              v-if="!isCompany && mateFormType === ''"
              class="form-group">
              <div class="form-label">
                <label
                  class="control-label"
                  for="media">2. narasuをどこで知りましたか？</label>
              </div>
              <div class="form-item">
                <div class="form-item-inline">
                  <div class="c-select_wrap">
                    <select
                      v-model="form.sign_up_enquete.media"
                      class="form-control c-select"
                      name="media">
                      <option
                        value=""
                        disabled
                        selected
                        style="display:none;">
                        一つ選択してください。
                      </option>
                      <option
                        v-for="(medium, index) in media"
                        :key="`medium${index}`"
                        :value="medium.value">
                        {{ medium.text }}
                      </option>
                    </select>
                  </div>
                </div>
                <p
                  v-if="errors['sign_up_enquete.media']"
                  class="error-text">
                  {{ errors["sign_up_enquete.media"][0] }}
                </p>
                <input
                  v-if="form.sign_up_enquete.media==='その他'"
                  v-model="form.sign_up_enquete.media_note"
                  placeholder="その他詳細を入力してください。"
                  type="text"
                  class="form-control my mr">
                <p
                  v-if="errors['sign_up_enquete.media_note']"
                  class="error-text">
                  {{ errors["sign_up_enquete.media_note"][0] }}
                </p>
              </div>
            </div>
          </div>
          <div
            v-if="isBtoC"
            style="color:red;text-align:center;">
            <template v-if="notice">{{ notice }}<br /></template>
            narasuは音楽を聴けるサービスではありません。
          </div>

          <cplus-music-consent-form
            v-if="isBtoB && company.is_cplus"
            @change-cplus_music_consent_agreed="handleCplusMusicConsentChangeEvent"/>

          <cplus-youtube-monetize-consent-form
            v-if="isBtoB && company.is_cplus"
            @change-cplus_youtube_monetize_agreed="handleCplusYoutubeMoneticzeConcentChangeEvent"/>

          <div class="consent-checkbox-area">
            <div class="checkbox">
              <label>
                <input
                  v-model="agreed"
                  type="checkbox">
                <div class="option-input"></div>
                利用規約に同意する （
                <a
                  href="#"
                  class="c-text-link"
                  @click.prevent="openTerms">
                  利用規約を見る
                </a>
                ）
              </label>
            </div>
          </div>
          <div class="form-btn-area">
            <button
              class="c-btn"
              :class="{ 'c-btn--off' : !checkRegister }"
              type="submit"
              name="submit"
              :disabled="!checkRegister"
              @click.prevent="onRegisterClicked">
              登録する<span class="c-btn__icon-arrow"></span>
            </button>
          </div>
          <div
            v-if="isLaunched"
            class="form-foot-linkarea">
            <router-link
              :to="{ name: 'login' }"
              class="c-text-link">
              ログイン
            </router-link>
          </div>
        </form>
      </div>
    </section>
  </div>
</template>

<script>
import CplusMusicConsentForm from './Terms/CplusMusicConsentForm'
import CplusYoutubeMonetizeConsentForm from './Terms/CplusYoutubeMonetizeConsentForm'

export default {
  components: {
    CplusMusicConsentForm,
    CplusYoutubeMonetizeConsentForm,
  },
  name: 'SignUpForm',
  props: {
    isCompany: {
      type: Boolean,
      default: false,
    },
    mateFormType: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: 'アカウント登録',
    },
    notice: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      form: {
        email: '',
        password: '',
        password_confirmation: '',
        rsId: '',
        mate: {
          form_type: null,
          code: null,
          graduation_year: null,
          graduation_month: null,
          student_id: null,
        },
        sign_up_enquete: {
          ageGroup: '',
          media: '',
          media_note: '',
        },
      },
      errors: {},
      company: {
        name: null,
      },
      agreed: false,
      ageGroups: [
        '10代',
        '20代',
        '30代',
        '40代',
        '50代',
        '60代以上',
      ],
      media: [
        { value: '知人からの紹介', text: '知人からの紹介' },
        { value: 'ネット記事（比較サイト）', text: 'ネット記事（比較サイト）' },
        { value: '公式SNS', text: '公式SNS' },
        { value: '公式note', text: '公式note' },
        { value: 'ネット検索', text: 'ネット検索' },
        { value: 'YouTubeでの紹介', text: 'YouTubeでの紹介' },
        { value: 'SNSでの紹介', text: 'SNSでの紹介' },
        { value: 'AIツール検索', text: 'AIツール検索' },
        { value: '広告（Google）', text: '広告（Google）' },
        { value: '広告（TikTok）', text: '広告（TikTok）' },
        { value: '広告（Instagram）', text: '広告（Instagram）' },
        { value: '広告（X）', text: '広告（X）' },
        { value: '広告（YouTube）', text: '広告（YouTube）' },
        { value: 'その他', text: 'その他' },
      ],
      graduationYearOptions: [
        { value: null, text: '-----' },
      ],
      graduationMonthOptions: [
        { value: null, text: '-----' },
      ],
      personal_number_text: '本人確認番号',
      cplusMusicConsentAgreed: false,
      cplusYoutubeMonetizeConsentAgreed: false,
    }
  },
  computed: {
    checkRegister() {
      if (this.isBtoC) {
        return this.agreed
      }

      if (this.company.is_cplus) {
        if (this.cplusMusicConsentAgreed
          && this.cplusYoutubeMonetizeConsentAgreed
          && this.agreed
        ) {
          return true
        }

        return false
      }

      return this.agreed
    },
  },
  mounted() {
    if (this.mateFormType !== '') {
      const nmId = window.sessionStorage.getItem('narasu_mate_id')
      this.fetchMate(this.$route.query.nmid ?? nmId)
    }
    if (this.mateFormType === 'mate') {
      // graduationYearOptionsに現在の年から2030年までの数字を連想配列で格納
      const currentYear = new Date().getFullYear()
      for (let i = currentYear; i <= currentYear + 4; i += 1) {
        this.graduationYearOptions.push({ value: i, text: `${i}年` })
      }
      this.form.mate.code = this.$route.query.nmid
    }
    this.form.rsId = this.$route.query.rsId
    const { code } = this.$route.query
    this.fetchItem()
    if (code) this.fetchEmail(code)
  },
  methods: {
    async fetchMate(nmId) {
      this.$store.commit('hideContents')
      const { data } = await window.axios.get('/api/client/narasu-mate', { params: { code: nmId, form_type: this.mateFormType } })
      if (data) {
        this.form.mate.code = data.code
        this.$store.commit('showContents')
        window.sessionStorage.setItem('narasu_mate_id', nmId)
        if (data.settings?.personal_number_text) {
          this.personal_number_text = data.settings.personal_number_text
        }
      } else {
        window.location = '/404'
      }
    },
    async fetchItem() {
      const { token } = this.$route.params
      if (token) {
        const { data } = await window.axios.get(`/api/client/company/${token}`)
        if (!data.cmap_login) {
          await this.$router.push({ name: 'index' })
          return
        }
        this.company = data
      }
    },
    async onRegisterClicked() {
      try {
        const params = this.form
        if (this.isCompany) {
          params.company_token = this.$route.params.token
        }
        if (this.form.rsId) {
          params.type = this.$route.query?.type ?? 'revenue-share'
        }
        params.mate.form_type = this.mateFormType
        const response = await window.axios.post('/api/client/registration/sign-up', params)
        const { name } = response.data
        if (name) {
          window.sessionStorage.setItem('RegisteredMemberName', name)
        }
        window.sessionStorage.removeItem('narasu_mate_id')
        window.location.href = '/client/sign-up-completed'
      } catch ({ response }) {
        const { errors } = response.data
        if (response.status === 422) {
          this.errors = errors
        }
        window.scrollTo(0, 0)
      }
    },
    createGraduationMonthOptions() {
      // graduationYearが現在の年ならば現在の月から終わりまで、現在の年でないならば01月から12月までの月を生成
      const currentYear = new Date().getFullYear()
      const currentMonth = new Date().getMonth() + 1
      this.graduationMonthOptions = [
        { value: null, text: '-----' },
      ]
      if (!this.form.mate.graduation_year) {
        return
      }
      if (this.form.mate.graduation_year === currentYear) {
        for (let i = currentMonth; i <= 12; i += 1) {
          this.graduationMonthOptions.push({ value: i, text: `${i}月` })
        }
      } else {
        for (let i = 1; i <= 12; i += 1) {
          this.graduationMonthOptions.push({ value: i, text: `${i}月` })
        }
      }
    },
    openTerms() {
      window.open('/client/static/terms')
    },
    async fetchEmail(code) {
      const { data } = await window.axios.get(`/api/client/registration/fetchCode?code=${encodeURIComponent(code)}`)
      this.form.email = data.data
    },
    handleCplusMusicConsentChangeEvent(result) {
      this.cplusMusicConsentAgreed = result
    },
    handleCplusYoutubeMoneticzeConcentChangeEvent(result) {
      this.cplusYoutubeMonetizeConsentAgreed = result
    },
  },
}
</script>

<style scoped>
.my {
  margin-top: 4px;
  margin-bottom: 4px;
}
.mr {
  margin-right: 10px;
}
</style>
